export const state = {
  message: '',
  type: '',
  loaded: false,
}
